import * as Sentry from '@sentry/vue'
import VueMask from 'v-mask'
import Vue from 'vue'
import * as pkg from '../package.json'
import App from './App.vue'
import './assets/tailwind.css'
import { createPinia, PiniaVuePlugin } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

Vue.use(PiniaVuePlugin)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

Vue.use(VueMask)

declare global {
	interface Date {
		isValid(): boolean
	}
}

Date.prototype.isValid = function () {
	return this.getTime() === this.getTime()
}

/**
 * Importacao do Vuetify para componentes responsivos
 * @Documentacao Vuetify: https://vuetifyjs.com/pt-BR/getting-started/quick-start
 */
import Vuetify from 'vuetify'
// import "vuetify/dist/vuetify.min.css";
Vue.use(Vuetify)
const opts = {}
const vuetify = new Vuetify(opts)

/**
 * Importação do Highcharts-Vue para gráficos interativos
 * @Documentação Highcharts-Vue: https://github.com/highcharts/highcharts-vue || Highcharts: https://api.highcharts.com/highcharts/
 */
import HighchartsVue from 'highcharts-vue'

Vue.use(HighchartsVue)

import Highcharts from 'highcharts'
import highchartsMore from 'highcharts/highcharts-more'
import boost from 'highcharts/modules/boost'
import Draggable from 'highcharts/modules/draggable-points'
import exporting from 'highcharts/modules/exporting'
import Gannt from 'highcharts/modules/gantt'
import Histogram from 'highcharts/modules/histogram-bellcurve'
import PatternFill from 'highcharts/modules/pattern-fill'
import Stock from 'highcharts/modules/stock'

Histogram(Highcharts)
highchartsMore(Highcharts)
boost(Highcharts)
exporting(Highcharts)
Gannt(Highcharts)
Draggable(Highcharts)
Stock(Highcharts)
PatternFill(Highcharts)

Highcharts.setOptions({
	lang: {
		resetZoom: 'Resetar zoom',
		months: [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro',
		],
		weekdays: [
			'Domingo',
			'Segunda-feira',
			'Terça-feira',
			'Quarta-feira',
			'Quinta-feira',
			'Sexta-feira',
			'Sábado',
		],
		shortMonths: [
			'Jan',
			'Fev',
			'Mar',
			'Abr',
			'Mai',
			'Jun',
			'Jul',
			'Ago',
			'Set',
			'Out',
			'Nov',
			'Dez',
		],
		rangeSelectorZoom: 'Período',
		rangeSelectorFrom: 'De',
		rangeSelectorTo: 'Até',
	},

	credits: {
		enabled: false,
	},
})
/**
 * Importacao da configuracao do Store do Vuex para gerenciamento de estado
 * @Documentacao Vuex: https://vuex.vuejs.org/
 */
import store from './store/index'

/**
 * Importacao das rotas utilizando o Vue-Router
 * @Documentacao VueRouter: https://router.vuejs.org/
 */
import router from './router'

/**
 * Exibicao de Latex
 * @Documentacao VueMathjax: https://www.npmjs.com/package/vue-mathjax
 */

import VueMathjax from 'vue-mathjax'
Vue.use(VueMathjax)

/**
 * Importacao do Vue2 Google Maps
 * @Documentacao Vue 2 Google Maps: https://www.npmjs.com/package/vue2-google-maps
 */

import * as VueGoogleMaps from 'vue2-google-maps'
import i18n from './VueI18n'
Vue.use(VueGoogleMaps, {
	load: {
		key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
	},
})
//// If you intend to programmatically custom event listener code
//// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
//// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
//// you might need to turn this on.
// autobindAllEvents: false,

//// If you want to manually install components, e.g.
//// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
//// Vue.component('GmapMarker', GmapMarker)
//// then disable the following:
// installComponents: true,

/**
 * GMapCluster, biblioteca para juntar os markers do dashboard
 */

import { components } from 'gmap-vue'
const { Cluster } = components

Vue.component('GmapCluster', Cluster)

/**
 * Documentação do v-calendar
 * https://vcalendar.io/
 */

import VDatePicker from 'v-calendar'
Vue.use(VDatePicker)

/**
 * Diretivas Customizadas
 */
import Closeble from './directives/Closeble'

Vue.directive('closable', Closeble)

Vue.config.productionTip = false

Sentry.init({
	Vue,
	dsn: process.env.VUE_APP_SENTRY_DSN,
	release: `smartforest-2@${pkg.version}`,
	environment: process.env.NODE_ENV,
	integrations: [
		new Sentry.BrowserTracing({
			// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
			// tracePropagationTargets: ["localhost", "https:yourserver.io/api/"],
			routingInstrumentation: Sentry.vueRouterInstrumentation(router),
		}),
		new Sentry.Replay(),
	],
	// Performance Monitoring
	tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

new Vue({
	i18n,
	vuetify,
	router,
	store,
	pinia,
	render: (h) => h(App),
}).$mount('#app')
